import create from "zustand";

const useToken = create(set => ({
    token: "",
    setToken: (data) => set(state => ({ token: data }))
}))
  
export default useToken;